import axios from 'axios'

const client = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
    headers: { 'Content-Type': 'application/json' },
})

// Attach JWT token to every outbound request if present in local storage
client.interceptors.request.use((config) => {
    const token = localStorage.getItem('gmc_token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

// Response interception handling.
// Strict endpoint matching: only wipe credentials when the profile identity
// check itself fails — not on login rejections, password reset failures,
// or any other auth-prefixed endpoint returning 401.
client.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            const url = err.config?.url || ''
            if (url.endsWith('/auth/me')) {
                localStorage.removeItem('gmc_token')
                window.location.href = '/login'
            }
        }
        return Promise.reject(err)
    }
)

export default client